import type React from 'react'

/**
 * Magnifier (56 × 56) — used by the Not found state.
 *
 * Path data is byte-identical to
 * `metro/docs/superpowers/specs/assets/stationcard-v2/icon-magnifier.svg`
 * (Figma export). Stroke is bound to `currentColor` so consumers can
 * tint via CSS `color: ...` (resolves to `--mm-color-text-secondary`
 * at the call site).
 */
export function IconMagnifier(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M24 38C31.732 38 38 31.732 38 24C38 16.268 31.732 10 24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M34 34L48 48" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}
